import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: block;\n  position: relative;\n\n  background: 0px;\n  border: 0px;\n  width: 100%;\n  padding: 0px;\n  margin: 0px;\n  line-height: 0px;\n  cursor: pointer;\n  padding: ",
        ";\n\n  & > svg > circle,\n  & > svg > line {\n    stroke: ",
        ";\n    stroke-width: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
export function Button(props) {
    return /*#__PURE__*/ _jsx(StyledButton, _object_spread({
        type: "button",
        id: "cart-button"
    }, props));
}
var StyledButton = styled.button(_templateObject(), function(param) {
    var styling = param.styling;
    return styling.padding;
}, function(param) {
    var styling = param.styling;
    return styling.fill;
}, function(param) {
    var styling = param.styling;
    return styling.strokeWidth;
});
